export default "__VITE_ASSET__BoRjuOAq__"